// import { ElementType } from 'react'
// import { AreaOfInterestSelection } from './AreaOfInterestSelection'
// import pdfImage from '../../images/gallerium/onDemand/pdf-thumbnail.png'
import posterImage from '../../images/gallerium/onDemand/poster-thumbnail.png'
import videoImage from '../../images/gallerium/onDemand/video-thumbnail.png'
import oralThumbnail from '../../images/gallerium/onDemand/oral-thumbnail.png'
import posterThumbnail from '../../images/gallerium/onDemand/poster2-thumbnail.png'

import {
  onDemandVideosType,
  virtualProductTheatreVideos,
  onDemandSymposiumsVideos,
} from './videos'
import routes from 'src/routes'

export interface onDemandCategoryType {
  id: string
  categoryName: string
  thumbnail: string
  destination: string
  videos?: Array<onDemandVideosType>
}

const onDemandCategories: Array<onDemandCategoryType> = [
  {
    id: 'cat1',
    categoryName: 'Oral Presentations',
    thumbnail: oralThumbnail,
    destination: routes.onDemandOral,
  },
  {
    id: 'cat2',
    categoryName: 'E Poster Presentations',
    thumbnail: posterThumbnail,
    destination: routes.onDemandPoster,
  },
  {
    id: 'cat3',
    categoryName: 'How I Do It',
    thumbnail: videoImage,
    destination: routes.onDemandVideo,
  },
  {
    id: 'cat4',
    categoryName: 'Virtual Product Theatre',
    thumbnail: videoImage,
    destination: '/on-demand/virtual-product-theatre',
    videos: virtualProductTheatreVideos,
  },
  {
    id: 'cat5',
    categoryName: 'On Demand Symposiums',
    thumbnail: videoImage,
    destination: '/on-demand/on-demand-symposiums',
    videos: onDemandSymposiumsVideos,
  },
  {
    id: 'cat6',
    categoryName: 'Best Basic Science Posters',
    thumbnail: posterImage,
    destination: routes.onDemandBbs,
  },
]

export { onDemandCategories }
